<template>
  <!-- 弹窗 -->
  <a-modal :title="title" v-model="isModalVisible" :width="widthDialog" @cancel="handleCancel">
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
      <a-button
        :disabled="fileList.length === 0"
        :loading="uploading"
        type="primary"
        @click="handleOk"
      >
        导入
      </a-button>
    </template>
    <div>
      <a-form-model ref="form" :model="model">
        <a-form-model-item label="第一步：下载模版">
          <a :href="templateUrl" @click="isDownload = true">{{ downloadText }}</a>
        </a-form-model-item>
        <a-form-model-item label="第二步：添加文件">
          <a-upload-dragger
            :disabled="!isDownload"
            accept=".xls,.xlsx"
            name="file"
            :file-list="fileList"
            :multiple="true"
            :action="uploadAction"
            :headers="tokenHeader"
            @change="handleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">添加文件</p>
            <p class="ant-upload-hint">(仅支持.xls或.xlsx格式的文件)</p>
          </a-upload-dragger>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction } from '@/api/manage'

export default {
  name: 'ImportQues',
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '导入问卷',
    },
    templateUrl: {
      type: String,
      default:
       window._CONFIG['resourceURL'] + '/school/sys/common/static/schoolEvaluation/测评表模版.xlsx',
    },
    downloadText: {
      type: String,
      default: '下载测评表Excel模版',
    },
  },
  data() {
    return {
      widthDialog: 700,
      isModalVisible: false, // 控制弹窗显示状态
      isDownload: true,
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=schoolEvaluation',
      model: {},
      fileList: [],
      uploading: false,
    }
  },
  methods: {
    showModal() {
      this.model = {}
      this.fileList = []
      this.isModalVisible = !this.isModalVisible // 显示弹窗
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })
      this.fileList = fileList
    },
    handleOk() {
      this.uploading = true
      const currfileList = this.fileList.map((item) => item.response.message)
      postAction('/schoolEvaluation/importSchoolEvaluation', {
        fileList: currfileList,
      })
        .then((res) => {
          console.log('导入测评信息：', res)
          if (res.success) {
            this.$message.success('导入成功')
            this.$emit('refreshTable') // 刷新列表数据
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },
    handleCancel() {
      this.isModalVisible = false // 取消后关闭弹窗
      this.model = {}
    },
  },
}
</script>

<style></style>
